import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { configureAmplify } from './config/aws-config';
import { store, persistor } from './store';
import App from './App';
import './index.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_AWS_ENV === 'prod') {
  Sentry.init({
    dsn: 'https://a96f099b37e6974fe4386a71c08f93dd@o4509262330658816.ingest.us.sentry.io/4509262334590977',
    integrations: [],
    sendDefaultPii: true,
  });
}

// Configure AWS Amplify
configureAmplify();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <App />
          </LocalizationProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>
);
